import { ArrowClockwise } from "react-bootstrap-icons";
import { isError, isErrorWithStatus } from "@/lib/type-guards";

interface Props {
  error: unknown;
}
export default function ErrorComponent(props: Props) {
  const message = isError(props.error) ? props.error.message : "Unknown error";
  const status = isErrorWithStatus(props.error) ? props.error.status : 500;

  return (
    <div className="h-100 d-flex justify-content-center align-items-center">
      <div className="text-center">
        <h1 className="mb-3 display-1">{status}</h1>
        <p className="text-muted">
          {status === 404 ? "Page not found" : "Oops! Something's not working."}
        </p>
        <p className="text-muted">Here's the error message:</p>
        <p className="text-muted border border-danger p-2 bg-danger-subtle rounded-1">
          {message}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="btn btn-primary"
        >
          <ArrowClockwise /> Try again
        </button>
      </div>
    </div>
  );
}
